"use strict";
window.onload = function() {
  const canvas = document.getElementById('configuration-canvas');
  const widthSelector = document.getElementById('SingleOptionSelector-0');
  const heightSelector = document.getElementById('SingleOptionSelector-1');
  const baseMaterials = document.querySelector('.base-material-wrapper');
  const topMaterials = document.querySelector('.top-material-wrapper');
  const topMaterialsCheckbox = document.querySelector('.js-same-material');
  const homeCamera = document.querySelector('.home-camera');
  const fullScreen = document.querySelector('.full-screen');
  const mainWrapper = document.querySelector('.configuration-scene');
  const screenImage = document.querySelector('.js-screen-image');
  const baseMaterialValue = document.querySelector('.js-base-material');
  const topMaterialValue = document.querySelector('.js-top-material');

  const scene = new THREE.Scene();
  const multipleCoef = 10;
  const legsSize = {
    height: 1.0,
    width: 0.8,
    depth: 0.8
  };
  let model, legsModel;
  const textureCube = new THREE.CubeTextureLoader()
    // .setPath('./assets/snow_dust/')
    .load(['//shop.abex.com/cdn/shop/t/18/assets/sleepyhollow_ft.jpg?3401', '//shop.abex.com/cdn/shop/t/18/assets/sleepyhollow_bk.jpg?3401', '//shop.abex.com/cdn/shop/t/18/assets/sleepyhollow_up.jpg?3401', '//shop.abex.com/cdn/shop/t/18/assets/sleepyhollow_dn.jpg?3401', '//shop.abex.com/cdn/shop/t/18/assets/sleepyhollow_rt.jpg?3401', '//shop.abex.com/cdn/shop/t/18/assets/sleepyhollow_lf.jpg?3401']);

  const camera = initCamera(canvas);
  const renderer = initScene(canvas);
  const controls = initControls(camera, renderer, multipleCoef);
  const store = {
    client: {
      isLoaded: false
    },
    constructor: {
      currentSize: {
        widthDepthIndex: 0,
        heightIndex: 0,
      },
      baseMaterial: 0,
      topMaterial: 0,
      quantity: 1,
      isSameAsBaseMaterial: false,
    },
    model: {}
  };

  const listeners = [
    {
      'target': window,
      'event': 'resize',
      'handler': resize
    },
    {
      'target': baseMaterials,
      'event': 'click',
      'handler': selectBaseMaterials
    },
    {
      'target': topMaterials,
      'event': 'click',
      'handler': selectTopMaterials
    },
    {
      'target': widthSelector,
      'event': 'change',
      'handler': changeSize
    },
    {
      'target': heightSelector,
      'event': 'change',
      'handler': changeSize
    },
    {
      'target': topMaterialsCheckbox,
      'event': 'change',
      'handler': toggleTopMaterialMode
    },
    {
      'target': homeCamera,
      'event': 'click',
      'handler': switchHomeCamera
    },
    {
      'target': fullScreen,
      'event': 'click',
      'handler': setFullscreen
    },
  ];

  function initControls(camera, renderer, multipleCoef) {
    const orbitControl = new THREE.OrbitControls(camera, renderer.domElement);
    orbitControl.enableDamping   = true;
    orbitControl.dampingFactor = 0.05;
    orbitControl.rotateSpeed = 0.1;
    orbitControl.minDistance = 130;
    orbitControl.maxDistance = 1500;
    orbitControl.maxPolarAngle = Math.PI / 2;
    orbitControl.target = new THREE.Vector3(0,10 * multipleCoef,0);
    orbitControl.keyPanSpeed = 1.0;
    orbitControl.keys = {
      LEFT: 37, //left arrow
      UP: 38, // up arrow
      RIGHT: 39, // right arrow
      BOTTOM: 40 // down arrow
    };
    return orbitControl;
  }

  function switchHomeCamera() {
    camera.position.set(360, 280, -20);
  }

  function setListeners(data) {
    listeners.forEach((item) => {
      item.target.addEventListener(item.event, item.handler.bind(data));
    })
  }

  function selectMaterial(texturesFull, index = 0) {
    model.material[index] = new THREE.MeshStandardMaterial( {roughness: 0.5, metalness: 0.5, overdraw: true})
    if (texturesFull){
      const loader = new THREE.TextureLoader();
      loader.load(
        texturesFull,
        (texture) => {
          model.material[index].map = texture;
          model.material[index].color.setHex(0XFFFFFF);
          model.material[index].needsUpdate = true;
        }
      );
    }
  }

  function selectBaseMaterials(e) {
    Array.prototype.forEach.call(baseMaterials.children, function(el) {
      el.classList.remove('active');
    });

    e.target.parentElement.classList.add('active');
    selectMaterial(e.target.dataset.value);
    baseMaterialValue.value = e.target.title;

    if (topMaterialsCheckbox.checked) {
      Array.prototype.forEach.call(topMaterials.children, function(el) {
        el.classList.remove('active');
      });

      selectMaterial(e.target.dataset.value, 1);
      topMaterialValue.value = e.target.title;
    }
  }

  function selectTopMaterials(e) {
    Array.prototype.forEach.call(topMaterials.children, function(el) {
      el.classList.remove('active');
    });

    e.target.parentElement.classList.add('active');
    selectMaterial(e.target.dataset.value, 1);
    topMaterialValue.value = e.target.title;

    topMaterialsCheckbox.checked = false;
  }

  function toggleTopMaterialMode() {
    let currentBaseMaterial = document.querySelectorAll('.base-material-item.active img')[0];

    if (topMaterialsCheckbox.checked) {
      Array.prototype.forEach.call(topMaterials.children, function(el) {
        el.classList.remove('active');
      });

      selectMaterial(currentBaseMaterial.dataset.value, 1);
      topMaterialValue.value = currentBaseMaterial.title;
    } else {
      let firstTopMaterial = document.querySelectorAll('.top-material-item img')[0];
      firstTopMaterial.parentElement.classList.add('active');

      selectMaterial(firstTopMaterial.dataset.value, 1);
      topMaterialValue.value = firstTopMaterial.title;
    }
  }

  function initCamera(canvas) {
    const camera = new THREE.PerspectiveCamera(65, canvas.offsetWidth / canvas.offsetHeight, 0.1, 10000);
    camera.position.set(360, 280, -20);
    return camera;
  }

  function initScene (canvas) {
    const renderer = new THREE.WebGLRenderer({ antialias: true, canvas: canvas, preserveDrawingBuffer: true });
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.soft = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.setSize(canvas.offsetWidth, canvas.offsetHeight);
    renderer.gammaInput = renderer.gammaOutput = true;
    renderer.toneMapping = THREE.LinearToneMapping;
    renderer.setClearColor( 0xEEEEEE, 1 );
    return renderer;
  }

  rendering();
  init();
  addLights();
  setListeners();
  function resize() {
    camera.aspect = mainWrapper.offsetWidth  / mainWrapper.offsetHeight;
    renderer.setSize(mainWrapper.offsetWidth - 5, mainWrapper.offsetHeight - 5);
    camera.updateProjectionMatrix()
  }

  function changeSize() {
    const sizes = widthSelector.value.split('x');
    model.geometry = new THREE.CylinderGeometry(
      sizes[0] * multipleCoef/2,
      sizes[1] * multipleCoef/2,
      heightSelector.value * multipleCoef,
      100
    );
    model.position.set(0,(heightSelector.value / 2 + legsSize.height) *multipleCoef, 0);
    setLegsPosition();
  }

  function addLights() {
    const spotLight = new THREE.SpotLight( 0xffffff, 0.7  );
    spotLight.position.set( 600, 800, 600 );

    spotLight.castShadow = true;
    spotLight.angle = 0.6;
    spotLight.penumbra = 1;
    spotLight.shadow.mapSize.width = 2048;
    spotLight.shadow.mapSize.height = 2048;

    spotLight.shadow.camera.near = 500;
    spotLight.shadow.camera.far = 4000;
    spotLight.shadow.camera.fov = 50;

    scene.add( spotLight );
    scene.add(new THREE.AmbientLight(0xffffff, 1.005));
  }

  Shopify.getImageFromCanvas = function() {
    screenImage.value = renderer.domElement.toDataURL("image/jpeg");
  }

  function rendering() {
    requestAnimationFrame(rendering);
    controls.update();
    renderer.render(scene, camera);
  }

  function createModel() {
    const sizes = widthSelector.value.split('x');
    const geometry = new THREE.CylinderGeometry(
      sizes[0] * multipleCoef/2,
      sizes[1] * multipleCoef/2,
      heightSelector.value * multipleCoef,
      200
    );
    const materials  = [
      new THREE.MeshStandardMaterial( {color: parseInt('000000'.toString(), 16), roughness: 0.5, metalness: 0.5, overdraw: true} ),
      new THREE.MeshStandardMaterial( {color: parseInt('eeeeee'.toString(), 16), roughness: 0.5, metalness: 0.5, overdraw: true} ),
      new THREE.MeshStandardMaterial( {color: parseInt('000000'.toString(), 16), roughness: 0.5, metalness: 0.5, overdraw: true} )
    ];
    model = new THREE.Mesh( geometry, materials  );
    model.castShadow = true;
    model.receiveShadow = true;
    model.position.set(0,((heightSelector.value / 2) + legsSize.height)*multipleCoef, 0);

    let currentBaseMaterial = document.querySelectorAll('.base-material-item.active img')[0];
    let currentTopMaterial = document.querySelectorAll('.top-material-item.active img')[0];
    
    const loader = new THREE.TextureLoader();
    loader.load(
      currentTopMaterial.dataset.value,
      (texture) => {
        model.material[1].map = texture;
        model.material[1].color.setHex(0XFFFFFF);
        model.material[1].needsUpdate = true;
      }
    );
    loader.load(
      currentBaseMaterial.dataset.value,
      (texture) => {
        model.material[0].map = texture;
        model.material[0].color.setHex(0XFFFFFF);
        model.material[0].needsUpdate = true;
      }
    );
    scene.add( model );
  }

  function createPlane() {
    const panelGeometry = new THREE.PlaneGeometry( 10000, 10000 );
    const panelMaterial = new THREE.MeshPhongMaterial({
      color: 0xdddddd,
      side: THREE.DoubleSide,
      reflectivity: 0,
    });
    const planeModel = new THREE.Mesh( panelGeometry, panelMaterial );
    planeModel.receiveShadow = true;
    planeModel.position.set(0,0,-200);
    planeModel.rotation.x -= Math.PI / 2;
    scene.add( planeModel );
  }

  function createLegs() {
    const geometry = new THREE.CylinderGeometry(
      legsSize.width * multipleCoef,
      legsSize.depth * multipleCoef,
      legsSize.height * multipleCoef,
      20
    );
    const material  = new THREE.MeshStandardMaterial( {color: 0x222222, roughness: 0.5, metalness: 0.5});
    const model = new THREE.Mesh( geometry, material);
    legsModel = new THREE.Group();
    for(let i=0; i<4; i++) {

      const clone = model.clone();
      legsModel.add(clone);
    }
    scene.add(legsModel);
    setLegsPosition()
  }

  function setLegsPosition() {
    const sizes = widthSelector.value.split('x');
    legsModel.children.forEach((item, index)=>{
      const angle = 2*Math.PI - (Math.PI/2)*index;
      const legsPosition = (sizes[0]/2 - legsSize.width*2) * multipleCoef;
      item.position.set(Math.sin(angle)*legsPosition,(legsSize.height / 2)* multipleCoef,Math.cos(angle)*legsPosition);
    });
  }

  function setFullscreen(e) {
    if(document.webkitIsFullScreen){
      if(document.exitFullscreen)
        document.exitFullscreen();
      else if(document.mozCancelFullScreen)
        document.mozCancelFullScreen();
      else if(document.webkitExitFullscreen)
        document.webkitExitFullscreen();
      else if(document.msExitFullscreen)
        document.msExitFullscreen();
      e.target.classList.remove('open');
    } else {
      if(mainWrapper.requestFullscreen)
        mainWrapper.requestFullscreen();
      else if(mainWrapper.mozRequestFullScreen)
        mainWrapper.mozRequestFullScreen();
      else if(mainWrapper.webkitRequestFullscreen)
        mainWrapper.webkitRequestFullscreen();
      else if(mainWrapper.msRequestFullscreen)
        mainWrapper.msRequestFullscreen();
      e.target.classList.add('open');
    }
  }

  function init() {
    createModel();
    createPlane();
    createLegs();
    resize();
  }
};
